import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
    isTradeIndividualOrderLoading: false,
    isInsertOrderLoading: false,
    isUpdateOrderLoading: false,
    isRemoveOrderLoading: false,
    isSaveTradingLimitsLoading: false
};

export const apiTradeIndividualOrder = createAsyncThunk(
    'eex/tradeIndividualOrder',
    async (payload, thunkAPI) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(
                '/eexapi/trade_individual_order',
                payload,
                {
                    headers: {
                        Authorization: token ? `${token}` : ''
                    }
                }
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.statusText
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiInsertOrder = createAsyncThunk(
    'eex/insertOrder',
    async (payload, thunkAPI) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post('/eexapi/insert_order', payload, {
                headers: {
                    Authorization: token ? `${token}` : ''
                }
            });
            return {
                data: response.data,
                status: response.status,
                statusText: response.statusText
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiUpdateOrder = createAsyncThunk(
    'eex/updateOrder',
    async (payload, thunkAPI) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post('/eexapi/update_order', payload, {
                headers: {
                    Authorization: token ? `${token}` : ''
                }
            });
            return {
                data: response.data,
                status: response.status,
                statusText: response.statusText
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiRemoveOrder = createAsyncThunk(
    'eex/removeOrder',
    async (payload, thunkAPI) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post('/eexapi/remove_order', payload, {
                headers: {
                    Authorization: token ? `${token}` : ''
                }
            });
            return {
                data: response.data,
                status: response.status,
                statusText: response.statusText
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiSaveTradingLimits = createAsyncThunk(
    'eex/saveTradingLimits',
    async (payload, thunkAPI) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(
                '/eexapi/save_trading_limits',
                payload,
                {
                    headers: {
                        Authorization: token ? `${token}` : ''
                    }
                }
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.statusText
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const eexSlice = createSlice({
    name: 'eex',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Trade Individual Order
        builder
            .addCase(apiTradeIndividualOrder.pending, (state) => {
                state.isTradeIndividualOrderLoading = true;
            })
            .addCase(apiTradeIndividualOrder.fulfilled, (state) => {
                state.isTradeIndividualOrderLoading = false;
            })
            .addCase(apiTradeIndividualOrder.rejected, (state) => {
                state.isTradeIndividualOrderLoading = false;
            });

        // Insert Order
        builder
            .addCase(apiInsertOrder.pending, (state) => {
                state.isInsertOrderLoading = true;
            })
            .addCase(apiInsertOrder.fulfilled, (state) => {
                state.isInsertOrderLoading = false;
            })
            .addCase(apiInsertOrder.rejected, (state) => {
                state.isInsertOrderLoading = false;
            });

        // Update Order
        builder
            .addCase(apiUpdateOrder.pending, (state) => {
                state.isUpdateOrderLoading = true;
            })
            .addCase(apiUpdateOrder.fulfilled, (state) => {
                state.isUpdateOrderLoading = false;
            })
            .addCase(apiUpdateOrder.rejected, (state) => {
                state.isUpdateOrderLoading = false;
            });

        // Remove Order
        builder
            .addCase(apiRemoveOrder.pending, (state) => {
                state.isRemoveOrderLoading = true;
            })
            .addCase(apiRemoveOrder.fulfilled, (state) => {
                state.isRemoveOrderLoading = false;
            })
            .addCase(apiRemoveOrder.rejected, (state) => {
                state.isRemoveOrderLoading = false;
            });

        // Save Trading Limits
        builder
            .addCase(apiSaveTradingLimits.pending, (state) => {
                state.isSaveTradingLimitsLoading = true;
            })
            .addCase(apiSaveTradingLimits.fulfilled, (state) => {
                state.isSaveTradingLimitsLoading = false;
            })
            .addCase(apiSaveTradingLimits.rejected, (state) => {
                state.isSaveTradingLimitsLoading = false;
            });
    }
});

export default eexSlice.reducer;
